import React from 'react';
import AllFiltersDropdown from 'app/shared/modules/filter/AllFiltersDropdown';
import FilterPresetList from 'app/shared/modules/filter/FilterPresetList';
import './style.scss';

const InlineFilter = () => {
  return (
    <div className="InlineFilter">
      <AllFiltersDropdown />
      <FilterPresetList />
    </div>
  );
};

export default InlineFilter;
